type Range = { min: number; max: number };

// Converts a value to a
// CSS percentage position
// within a range
export const getPercentage = (value: number, { min, max }: Range) =>
  ((value - min) / (max - min)) * 100;

// Mirrors Radix's internal getThumbInBoundsOffset.
// Returns a px correction so that at 0% and 100% the element's center
// aligns with the track edges instead of overflowing.
export const getThumbInBoundsOffset = (thumbSize: number, percent: number) => {
  const halfWidth = thumbSize / 2;
  return halfWidth - (halfWidth / 50) * percent;
};
